import { Link } from "react-router-dom";
import { featuredTracks } from "@/mocks/taxonomy";
import { videos } from "@/mocks/videos";

export default function FeaturedTracks() {
  return (
    <section className="bg-background-100/60 py-10 md:py-14">
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-6 lg:px-10">
        <div className="mb-6">
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">热门推荐专题</h2>
          <p className="mt-1.5 text-sm text-foreground-600">精选内容合集，左右滑动发现你的下一部心头好</p>
        </div>

        <div className="no-scrollbar flex gap-4 overflow-x-auto pb-2">
          {featuredTracks.map((track) => (
            <article
              key={track.id}
              className="w-[280px] shrink-0 rounded-lg border border-background-200 bg-background-100 p-4 sm:w-[340px] md:p-5"
            >
              <div className="flex items-center gap-2.5">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500/15 text-accent-400">
                  <i className={`${track.icon} text-xl`}></i>
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-950">{track.title}</h3>
              </div>
              <p className="mt-3 text-xs leading-relaxed text-foreground-600">{track.desc}</p>

              <div className="mt-4 grid grid-cols-4 gap-2">
                {track.videoIds.map((vid) => {
                  const video = videos.find((v) => v.id === vid);
                  if (!video) return null;
                  return (
                    <Link
                      key={vid}
                      to={`/detail/${vid}`}
                      title={video.title}
                      className="group relative block aspect-[2/3] overflow-hidden rounded-md bg-background-200"
                    >
                      <img
                        src={video.cover}
                        alt={`${video.title}封面`}
                        className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      />
                    </Link>
                  );
                })}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}